import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

// if value is a date, convert to a string; otherwise return original value
// This should be used to format strings for communication with the backend.
// Do not use this for displaying dates.
export function dateToString(value: any): string {
  return value instanceof Date ? moment(value.getTime())
    .format(DATE_FORMAT) : moment.isMoment(value) ? value.format(DATE_FORMAT) : value;
}
